import { usd } from "@/lib/calc";
import { Warehouse, Users, PackagePlus, Truck } from "lucide-react";

const cards = [
  { key: "storage", label: "Storage", unit: "/ sqft · mo", icon: Warehouse },
  { key: "labor", label: "Labor Rate", unit: "/ hour", icon: Users },
  { key: "inbound", label: "Inbound", unit: "/ pallet", icon: PackagePlus },
  { key: "outbound", label: "Outbound", unit: "/ pallet", icon: Truck },
];

export default function RateCards({ rates }) {
  return (
    <div className="grid grid-cols-2 overflow-hidden rounded-sm border border-slate-200 bg-white lg:grid-cols-4">
      {cards.map(({ key, label, unit, icon: Icon }, i) => (
        <div
          key={key}
          className={`flex flex-col gap-2 p-4 ${i % 2 === 0 ? "border-r border-slate-200" : ""} ${
            i < 2 ? "border-b border-slate-200 lg:border-b-0" : ""
          } ${i === 2 ? "lg:border-r" : ""}`}
          data-testid={`rate-card-${key}`}
        >
          <div className="flex items-center gap-2 text-slate-400">
            <Icon className="h-3.5 w-3.5" />
            <span className="text-[10px] font-semibold uppercase tracking-[0.18em]">{label}</span>
          </div>
          <div className="font-mono-plex text-xl font-semibold text-slate-900" data-testid={`rate-value-${key}`}>
            {usd(rates[key])}
          </div>
          <div className="text-[11px] text-slate-400">{unit}</div>
        </div>
      ))}
    </div>
  );
}
